import { Button, Modal } from "react-bootstrap";
import "./GuideDownload.style.scss";
import { useTranslation } from "react-i18next";

interface IGuideDownloadProps {
  showGuideDownloadModal: boolean;
  closeButtonGuide: any;
  doNotOpenGuide: any;
  handleChangeGuide: any;
  goEcoAdmin: any;
}
const GuideDownloadModal = ({
  showGuideDownloadModal,
  closeButtonGuide,
  doNotOpenGuide,
  handleChangeGuide,
  goEcoAdmin,
}: IGuideDownloadProps) => {
  const { t } = useTranslation();
  return (
    <Modal
      show={showGuideDownloadModal}
      onHide={() => closeButtonGuide()}
      className="guide-modal"
      style={{ opacity: 1 }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("siteManagement.popup.guide.title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="msg-body">{t("siteManagement.popup.guide.msg1")}</p>
        <p className="msg-desc">{t("siteManagement.popup.guide.msg2")}</p>
        <a href={t("siteManagement.popup.guide.download")} target="_blank">
          <Button className="btn btn-green height h-36">
            {t("siteManagement.popup.guide.downloadAdmin")}
          </Button>
        </a>
        <p className="goAdmin" onClick={goEcoAdmin}>
          {t("siteManagement.popup.guide.moveAdmin")}
        </p>
        {/* <input
          type="checkbox"
          id="close30Days"
          checked={doNotOpenGuide}
          onChange={handleChangeGuide}
        />
        <label className="close30d" htmlFor="close30Days">
          {t("siteManagement.popup.guide.close30Days")}
        </label> */}
      </Modal.Body>
    </Modal>
  );
};

export default GuideDownloadModal;
